import { render, staticRenderFns } from "./ImageAttached.vue?vue&type=template&id=e6e8a320&"
import script from "./ImageAttached.vue?vue&type=script&lang=js&"
export * from "./ImageAttached.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports